var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('drop-down',[_c('a',{staticClass:"dropdown-item text-danger",attrs:{"href":"#"}},[_c('i',{staticClass:"nc-icon nc-button-power"}),_vm._v(" Log out ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }